import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Bericht } from '../shared/models/Bericht';
import { BerichtenService } from '../shared/berichtenservice/berichten.service';
import { Router } from '@angular/router';
import { UploadService } from '../shared/upload/upload.service';
import { Upload } from '../shared/models/upload';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { UploadStatus } from '../shared/models/uploadStatus';
import { of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
             selector: 'app-bericht-form',
             templateUrl: './bericht-form.component.html',
             styleUrls: ['./bericht-form.component.scss']
           })
export class BerichtFormComponent implements OnInit {
  berichtForm: FormGroup;
  selectedImg: FileList;
  invalidForm = false;
  error = false;
  typeError = false;
  sizeError = false;
  private readonly acceptedTypes = [
    'image/bmp',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ];


  constructor(private formBuilder: FormBuilder,
              private berichtenService: BerichtenService,
              private uploadService: UploadService,
              private router: Router) {
  }

  ngOnInit() {
    this.buildForm();
    this.berichtForm.valueChanges.subscribe(() => {
      this.invalidForm = false;
    });
  }

  private buildForm() {
    this.berichtForm = this.formBuilder.group({
                                                naam: ['', Validators.required],
                                                text: ['', Validators.required]
                                              });
  }

  detectAfbeelding(event) {
    const selectedFile = event.target.files;
    const isImageType = this.acceptedTypes.indexOf(selectedFile.item(0).type) !== -1;
    if (isImageType) {
      this.typeError = false;
      if (selectedFile.item(0).size > 2500000) {
        this.sizeError = true;
      } else {
        this.sizeError = false;
        this.selectedImg = selectedFile;
      }
    } else {
      this.typeError = true;
    }
  }

  submit() {
    this.uploadService.reset();
    if (this.berichtForm.valid && !this.typeError && !this.sizeError) {
      let imageId = this.berichtForm.get('naam').value + '_' + new Date().valueOf();
      this.uploadAfbeelding(imageId)
        .pipe(
          filter((status: UploadStatus) => status.status === 'upload success'),
          switchMap((status: UploadStatus) => {
            imageId = (status.uploadName === 'none') ? environment.defaultImageID : status.uploadName;
            const bericht = new Bericht(this.berichtForm.get('naam').value,
                                        this.berichtForm.get('text').value,
                                        imageId,
                                        'placeholder');
            return this.berichtenService.addBericht(bericht);
          }),
          catchError((error) => {
            console.error('submit error: ', error);
            this.error = true;
            return throwError(error);
          })
        )
        .subscribe(() => {
          this.router.navigate(['/overzicht']);
        });
    } else {
      this.invalidForm = true;
    }
  }

  private uploadAfbeelding(imageId: string) {
    if (this.selectedImg) {
      const image = this.selectedImg.item(0);
      const upload = new Upload(imageId, image, imageId, 'url', 0);
      return this.uploadService.uploadImage(upload);
    } else {
      return of(new UploadStatus('none', 100, 'upload success'));
    }
  }
}
